import { Check, Circle, Loader2 } from "lucide-react";

export default function Timeline({ steps = [] }) {
  return (
    <div className="flex flex-col gap-3" data-testid="dev-timeline">
      {steps.map((s, i) => {
        const done = s.state === "done";
        const current = s.state === "current";
        return (
          <div
            key={i}
            className={`flex items-center gap-3 transition-opacity ${
              done ? "opacity-90" : current ? "opacity-100" : "opacity-35"
            }`}
          >
            <span className="flex h-6 w-6 items-center justify-center rounded-full border border-white/10">
              {done ? (
                <Check className="h-3.5 w-3.5 text-white" />
              ) : current ? (
                <Loader2 className="h-3.5 w-3.5 text-white animate-spin" />
              ) : (
                <Circle className="h-2 w-2 text-white/40" />
              )}
            </span>
            <span
              className={`text-sm tracking-wide ${
                current ? "text-white font-medium" : "text-white/60"
              }`}
            >
              {s.label}
            </span>
            {current && (
              <span className="ml-auto text-[10px] uppercase tracking-widest text-white/40">
                em andamento
              </span>
            )}
          </div>
        );
      })}
    </div>
  );
}
